import {
  RootFiCompany,
  RootFiConnectionStatus,
  RootFiIntegration,
  RootfiSyncStatus,
} from '@prisma/client';
import type {
  RootfiIntegrationListItem,
} from '@commenda/types/src/root-fi/types';

export const getRootfiIntegrationNameFromIntegration = (
  integration: RootFiIntegration
) => {
  if (integration === RootFiIntegration.NETSUITE) {
    return 'NetSuite';
  }

  return integration
    ?.toLowerCase()
    .replaceAll('_', ' ')
    .replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
};

export const filterVisibleIntegrations = (
  integrations: ReadonlyArray<RootfiIntegrationListItem>
): RootfiIntegrationListItem[] => {
  return integrations.filter(
    (integration) =>
      integration.connectionStatus !== RootFiConnectionStatus.PENDING
  );
};

export const sortIntegrationsByStatus = (
  integrations: RootfiIntegrationListItem[]
) => {
  return [...integrations].sort((a, b) => {
    // Connected status should be at the top
    // Syncing status should be at the bottom
    // For all other statuses, maintain their relative order

    if (
      a.connectionStatus === RootFiConnectionStatus.CONNECTED &&
      b.connectionStatus !== RootFiConnectionStatus.CONNECTED
    )
      return -1;
    if (
      b.connectionStatus === RootFiConnectionStatus.CONNECTED &&
      a.connectionStatus !== RootFiConnectionStatus.CONNECTED
    )
      return 1;

    if (
      a.connectionStatus === RootFiConnectionStatus.PENDING &&
      b.connectionStatus !== RootFiConnectionStatus.PENDING
    )
      return 1;
    if (
      b.connectionStatus === RootFiConnectionStatus.PENDING &&
      a.connectionStatus !== RootFiConnectionStatus.PENDING
    )
      return -1;

    return 0;
  });
};

export const getIntegrationSyncState = (
  integrations: RootFiCompany[]
): boolean => {
  const isIntegrationSyncInProgress = !!integrations?.find(
    (i) =>
      i.syncStatus === RootfiSyncStatus.IN_PROGRESS ||
      i.syncStatus === RootfiSyncStatus.PENDING
  );
  return isIntegrationSyncInProgress;
};
